<template>
  <p>
    <span
      class="has-text-weight-medium my-label"
      v-bind:class="{ 'normal-label-width': !wideLabel, 'wide-label-width': wideLabel}"
    >{{label}}</span>
    <span v-bind:id='id' class="my-value">{{value}}</span>
    <span v-html="units"></span>
  </p>
</template>

<script>
export default {
  props: {
    id: String,
    label: String,
    wideLabel: Boolean,
    value: String,
    units: String,
  },
};
</script>

<style scoped>
.normal-label-width {
  width: 8em;
}
.wide-label-width {
  width: 12em;
}
.my-label {
  display: inline-block;
  padding-bottom: 0.25em;
}
.my-value::after {
  content: " ";
}
</style>
